// Filters out known noisy Smartico SDK console messages that are emitted
// directly from scactus.js (we can't change the SDK). Cleared on full reload.
const NOISE_PATTERNS = [
  /Abort identification of visitor .* because product ACQUISITION is not enabled/i,
  /reading 'tournamentId'/i,
  /\[Smartico\]\[lifecycle\]/i,
  /<Suspense> is an experimental feature/i,
];

export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const shouldSuppress = (args: unknown[]) => {
    return args.some((arg) => {
      const text =
        typeof arg === 'string' ? arg : arg instanceof Error ? arg.message : '';

      return NOISE_PATTERNS.some((re) => re.test(text));
    });
  };

  (['log', 'info', 'warn', 'error', 'debug'] as const).forEach((method) => {
    const original = console[method].bind(console);

    console[method] = (...args: unknown[]) => {
      if (shouldSuppress(args)) return;
      original(...args);
    };
  });
});
